import { render, staticRenderFns } from "./marketing-address-disclaimer-modal.vue?vue&type=template&id=4587d291"
import script from "./marketing-address-disclaimer-modal.vue?vue&type=script&lang=js"
export * from "./marketing-address-disclaimer-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports